import PageHero from '@/components/feature/PageHero';
import { launchHero } from '@/mocks/launch';

export default function Hero() {
  return (
    <PageHero
      eyebrow={launchHero.eyebrow}
      title={launchHero.title}
      titleHighlight={launchHero.titleHighlight}
      subtitle={launchHero.subtitle}
      desc={launchHero.desc}
      imageUrl="https://readdy.ai/api/search-image?query=Modern%20digital%20commerce%20cafe%20flagship%20space%20with%20glowing%20smart%20digital%20shelf%20screens%20and%20warm%20wooden%20interior%2C%20people%20using%20mobile%20app%20for%20digital%20consumption%2C%20deep%20navy%20and%20eco%20green%20accent%20lighting%2C%20futuristic%20national%20strategy%20technology%20aesthetic%2C%20editorial%20photography%20soft%20cinematic%20lighting&width=1800&height=1200&seq=launch-hero-01&orientation=landscape"
      imageAlt="帝星数商综合体 0# 首发验证场景"
      imageTitle="九畴云铺 0# 帝星数商综合体"
    />
  );
}